<!--消息中心-->
<template>
  <div class="message border com-table">
    <div class="message-top clear">
      <el-checkbox class="fl" v-model="checkNoRead">仅看未读消息 <span>({{noReadNum}})</span></el-checkbox>
      <el-input
        @keyup.enter.native="requestList"
        class="fr"
        placeholder="请输入内容"
        v-model="searchForm.contents">
        <i slot="prefix" class="el-input__icon el-icon-search" @click="requestList"></i>
      </el-input>
    </div>
    <div class="message-tabs">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="系统消息" name="first">
          <el-table
            :data="recomList"
            @row-click="clickTable"
            @expand-change="expandSelect"
            :row-key='getRowKeys'
            :expand-row-keys="expands"
            @selection-change="handleSelectionChange"
            ref="refTable"
            style="width: 100%">
            <template slot="empty">
              <no-data></no-data>
            </template>
            <el-table-column type="expand">
              <template slot-scope="props">
                <div class="message-content">{{props.row.contents}}</div>
              </template>
            </el-table-column>
            <el-table-column
              type="selection"
              width="60">
            </el-table-column>
            <el-table-column
              width="60">
              <template slot="header" slot-scope="scope">
                <img style="cursor:pointer;" src="../../assets/images/message-center/delate.png" alt=""
                     @click="handleDelAll">
              </template>
              <template slot-scope="scope">
                <img style="cursor:pointer;" src="../../assets/images/message-center/delate.png" alt=""
                     @click="handleDelete(scope.$index, table.list)">
              </template>
            </el-table-column>
            <el-table-column
              label="消息内容"
              prop="title">
            </el-table-column>
            <el-table-column
              label="接收日期 "
              prop="createTime">
            </el-table-column>
            <el-table-column
              label="消息类型"
              class="pr"
              prop="type">
              <template slot-scope="scope">
                <!--0-系统通知,1-用户通知-->
                <span v-if="scope.row.type === 0">系统通知</span>
                <span v-if="scope.row.type === 1">用户通知</span>
                <el-badge v-if="scope.row.status === 0" value="new" class="item-new pa"></el-badge>
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
        <!--<el-tab-pane label="系统消息" name="second">系统消息</el-tab-pane>
        <el-tab-pane label="系统消息" name="third">系统消息</el-tab-pane>-->
      </el-tabs>

    </div>
    <el-pagination
      class="pagination"
      layout="total, sizes, prev, pager, next, jumper"
      :current-page.sync="table.pagination.page"
      :total="table.pagination.totalRow"
      :page-size="table.pagination.pageSize"
      :page-sizes="table.pagination.pageSizes"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange">
    </el-pagination>
  </div>
</template>
<script>
  import Api from '@/api/client/massage-center'
  import { SearchArgument } from '@/models/client/message-center'
  import ResponseParse from '@/utils/response-parse'

  export default {
    created () {
      this.requestList()
    },
    computed: {
      recomList () {
        let data = []
        if (this.checkNoRead) {
          this.table.list.forEach(item => {
            if (item.status === 0) {
              data.push(item)
            }
          })
        }
        return this.checkNoRead ? data : this.table.list
      },
      noReadNum () {
        let count = 0
        this.table.list.forEach(item => {
          if (item.status === 0) {
            count++
          }
        })
        return count
      }
    },
    data () {
      return {
        expands: [],
        getRowKeys (row) {
          return row.id
        },
        checkNoRead: false,
        searchForm: new SearchArgument(),
        activeName: 'first',
        table: {
          loading: true,
          list: [],
          pagination: {}
        },
        multipleSelection: []
      }
    },
    methods: {
      requestList () {
        let search = Object.assign({}, this.searchForm, this.table.pagination)
        Api.list({'search': search}, response => {
          let status = response.status
          let data = response.data
          if (status >= 200 && status <= 204) {
            this.table.list = data
            this.table.pagination = ResponseParse.pagination(response.headers)
          } else {
            this.table.list = []
          }
        })
      },
      handleDelete (index, rows) {
        this.$confirm('确定删除?', {
          confirmButtonText: '是',
          cancelButtonText: '否',
          type: 'warning'
        }).then(() => {
          Api.delOne(rows[index].id, response => {
            let status = response.status
            if (status >= 200 && status <= 204) {
              this.$message.success('删除成功！')
              rows.splice(index, 1)
            } else {
              this.$message.error('删除失败！')
            }
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
      },
      handleDelAll () {
        const array = this.multipleSelection
        let ids = []
        array.forEach(item => {
          ids.push(String(item.id))
        })
        if (array.length === 0) {
          this.$message.error('请先选择要选择的信息！')
          return false
        }
        this.$confirm('确定删除?', {
          confirmButtonText: '是',
          cancelButtonText: '否',
          type: 'warning'
        }).then(() => {
          Api.delAll({ids: ids}, response => {
            let status = response.status
            if (status >= 200 && status <= 204) {
              this.$message.success('删除成功！')
              this.requestList()
            } else {
              this.$message.error('删除失败！')
            }
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
      },
      handleSelectionChange (val) {
        this.multipleSelection = val
      },
      handleSizeChange (val) {
        this.table.pagination.pageSize = val
        this.requestList()
      },
      handleCurrentChange (val) {
        this.table.pagination.page = val
        this.requestList()
      },
      clickTable (row, index, e) {
        this.$refs.refTable.toggleRowExpansion(row)
      },
      expandSelect (row, expandedRows) {
        if (expandedRows.length) {
          this.expands = []
          if (row) {
            this.expands.push(row.id)
          }
          // lhc只有未读的信息才发送已读接口
          if (row.status === 0) {
            this.setReady(row.id)
          }
        } else {
          this.expands = []
        }
      },
      setReady (id) {
        Api.setRead(id, response => {
          let status = response.status
          if (status >= 200 && status <= 204) {
            // TODO 接口获取未读信息websoket推送 rest/tourist/push-message/not/notifications
            this.requestList()
          } else {
            this.$message.error('读取失败！')
          }
        })
      }
    }
  }
</script>
<style scoped lang="scss">
  @import '../../assets/styles/env';

  .message {
    background: $color-white;
    padding: 21px 48px 100px 30px;
    color: $color-gray;
    font-size: $font-secondary;
    &-top {
      .el-input {
        width: 380px;
      }
    }
    &-tabs {
      .message-title {
      }
      .message-content {
        padding: 23px 87px 27px 69px;
        background: #F9F9F9;
        color: #666666;
        font-size: 14px;
      }
    }
  }
</style>
<style lang="scss">
  .message {
    &-tabs {
      .el-tabs__header {
        margin: 0;
      }
      .el-collapse-item__content {
        padding-bottom: 0;
      }
      .el-table__expanded-cell[class*=cell] {
        padding: 0;
      }
    }
    &-top {
      .el-input--prefix .el-input__inner {
        padding-left: 15px;
        padding-right: 30px;
      }
      .el-input__prefix {
        left: 350px;
        cursor: pointer;
      }
    }
    .item-new {
      top: 3px;
      left: 74px;
      .el-badge__content {
        font-size: 12px;
        height: 15px;
        line-height: 15px;
        padding: 0 4px;
      }
    }
    .el-checkbox__input.is-checked + .el-checkbox__label, .el-checkbox {
      color: red;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/client/MessageCenter.vue